'use strict'

Vue.component('awe-catalog-selector', {
  props:{
    wtbid: {type: String},
    country:{type: String},
    lang: {type: String, default: 'en'},
    products:{type: Array, default: () => {return [] }},
    cascading: {type: Boolean, default: false}, // Whether facets are linked or independant
    productPattern:{type: String, default: 'np'},
    defaultEan: {type: String, default: ''},
    idType: {type: String}, // type of product id used to identify the selected product
    productSearchEnabled: {type: Boolean, default: false},
    showProductList: {type: Boolean, default: true},
    ready: {type: Boolean, default: false},
  },
  mixins:[i18nUpdateMixin],

  data: function(){
    return {
      filters: [], // selected values
      i18n: this.$root.i18n,
      utils: this.$root.Utils,
      searchProductSelected: false, 
    }
  },
  methods:{
    productSelect: function(pdt){
      this.$emit('product-select', pdt)
    },
    updateEans: function(pdt) {
      this.$emit('eans-update', {
        defaultEan: pdt.ean,
        eans: pdt.eans,
      })
    },
    updateSearchProductSelected: function(selected) {
      this.searchProductSelected = selected;
    },
    getProductLabel: function(pdt){
      return Utils.buildProductLabel(pdt, this.productPattern)
    },
  },
  template: `
  <div class="catalog-selector-ctnr">
    <awe-facets-logic
      :wtbid="wtbid" :country="country" :lang="lang" :cascading="cascading" :default-ean="defaultEan"
      :set-default-filters="true"
      v-on:eans-update="searchProductSelected ? null : $emit('eans-update', $event)"
      v-slot="{facets, eans, defaultEan, updateFacets, clearAllFilters}"
      :ready="ready"
    >

      <div>
        <div>
          <awe-product-search v-if="productSearchEnabled"
            ref="productSearch"
            :wtbid="wtbid" :country="country" :locale="lang"
            v-on:product-select="$emit('product-select', $event)"
            v-on:reset-filters="clearAllFilters($event)"
            v-on:change="updateEans"
            v-on:product-selected="updateSearchProductSelected"
          ></awe-product-search>
        </div>
        <div class="catalog-selector" :class="{'no-pdt':!showProductList}" :data-facet-count="facets.length">
          <div v-for="(facet, i) in facets" class="facet" :data-key="facet.key">
            <label class="facet-lbl">{{facet.name || facet.key}}</label>

            <awe-dropdown :items="facet.values" item-label="value"
              :ref="'ddn_'+facet.key"
              v-on:change="updateFacets($event, i)"
              :default-idx="facet.values.findIndex(x => x.selected)"
              :listId="facet.key"
              :name="facet.name"
              :use-img="facet.withImg"
            >

              <template #selection="slotProps">
                <slot name="facet-selection" :item="slotProps.item" :expanded="slotProps.expanded">
                </slot>
              </template>
              <template #arrow="slotProps">
                <slot name="arrow" :expanded="slotProps.expanded">
                </slot>
              </template>
              <template #option="slotProps">
                <slot name="facet-option" :item="slotProps.item">
                </slot>
              </template>
            </awe-dropdown>
          </div>

          <div class="pdt-ctnr" v-if="showProductList">
            <label>{{i18n.getString('PRODUCT_DROPDOWN_LABEL')}}</label>

            <awe-dropdown :items="products" ref="dropdown"
              v-on:change="productSelect"
              name="product"
              :item-label="getProductLabel"
              :use-img="productPattern.startsWith('i')"
              :default-idx="products.findIndex(pdt => utils.isDefaultProduct(pdt, defaultEan, idType))"
            >
            <template #selection="slotProps">
              <slot name="pdt-selection" :item="slotProps.item" :expanded="slotProps.expanded">
              </slot>
            </template>
            <template #arrow="slotProps">
              <slot name="arrow" :expanded="slotProps.expanded">
              </slot>
            </template>
            <template #option="slotProps">
              <slot name="pdt-option" :item="slotProps.item">
              </slot>
            </template>
            </awe-dropdown>

          </div>
        </div>
      </div>
    </awe-facets-logic>
  </div>
  `
})
